// extracted by mini-css-extract-plugin
export default {"tabsNav":"detailsTabs_tabsNav__vnhGZ"};